module.exports = __webpack_public_path__ + "static/media/banner2_dark.ac115adc.png";